import type { FC } from "react"

import { useTranslation } from "react-i18next"
import styled from "styled-components"

import { ReactComponent as Compass } from "@svg/compass/compass-mobile.svg"
import { ReactComponent as Reset } from "@svg/compass/reset.svg"
import { ReactComponent as ZoomOut } from "@svg/minus.svg"
import { ReactComponent as ZoomIn } from "@svg/plus.svg"

import { Icon } from "./Styles"

const ResetIcon = styled(Icon)`
  svg {
    width: 18px;
    height: 18px;
    path {
      fill: #516683;
    }
  }
  margin-bottom: 10px;
`
const ZoomIcon = styled(Icon)`
  box-shadow: none;
  border-radius: 0;
  svg {
    width: 12px;
    height: 12px;
    path {
      fill: #516683;
    }
  }
`
const ZoomIcons = styled(Icon)`
  display: flex;
  overflow: hidden;
  flex-direction: column;
  height: fit-content;
  ${ZoomIcon} {
    :last-of-type {
      border-top: 1px solid #51668332;
    }
  }
`
const Icons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`
const StyledCompass = styled(Compass)`
  filter: drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.5));
`

export const CompassRose: FC<{
  zoomIn: VoidFunction
  zoomOut: VoidFunction
  reset: VoidFunction
}> = ({ zoomIn, zoomOut, reset }) => {
  const { t } = useTranslation()

  return (
    <>
      <StyledCompass height={`60px`} width={`56px`} />
      <Icons>
        <ResetIcon onClick={reset} title={t(`resetImage`)} data-role="option">
          <Reset />
        </ResetIcon>
        <ZoomIcons>
          <ZoomIcon onClick={zoomIn} title={t(`zoomIn`)} data-role="option">
            <ZoomIn />
          </ZoomIcon>
          <ZoomIcon onClick={zoomOut} title={t(`zoomOut`)} data-role="option">
            <ZoomOut />
          </ZoomIcon>
        </ZoomIcons>
      </Icons>
    </>
  )
}
